import React from 'react';
import { GlobeIcon, InstagramIcon, MailIcon } from 'lucide-react';
import { INSTAGRAM_URL, INSTAGRAM_USER, SOPORTE_EMAIL, WEB_LABEL, WEB_URL } from '../data/content';
const linkClass = 'underline underline-offset-4 transition-colors duration-150 ease-out hover:text-oro';
export function Footer() {
  return <footer className="w-full bg-navy-deep px-5 py-8 pb-20 text-white/55 sm:px-8 sm:py-10 lg:pb-10" data-id="element-34" data-mp="36q92d2n08sq0">
      <div className="mx-auto w-full max-w-5xl" data-id="element-35" data-mp="3ugbqj7nstejc">
        <div className="flex flex-col gap-5 sm:flex-row sm:items-start sm:justify-between sm:gap-8" data-id="element-36" data-mp="38qtqszerhoj">
          <div data-id="element-37" data-mp="3lec7k9t840dr">
            <p className="font-display text-[15px] font-bold uppercase tracking-tight text-white sm:text-base" data-id="element-38" data-mp="3levi35gjnmhr">
              SOS Veraz — Protocolo de Salida Rápida
            </p>
            <p className="mt-1 text-[13px] text-white/50 sm:text-sm" data-id="element-39" data-mp="29z6x2jmuoxjl">
              Un producto de <span className="text-oro" data-id="element-40" data-mp="2a1jkhcbdo041">Creativo Digital™</span>
            </p>

            <ul className="mt-3 flex flex-col gap-1.5 text-[13px] sm:text-sm" data-id="element-41" data-mp="2ezl0fodibjba">
              <li className="flex items-center gap-2" data-id="element-42" data-mp="3labt60db0esh">
                <MailIcon className="h-4 w-4 shrink-0 text-oro" aria-hidden="true" data-id="element-43" data-mp="3gapd7j63ckfz" />
                <a href={`mailto:${SOPORTE_EMAIL}`} className={linkClass} data-id="element-44" data-mp="3v7q5bns72hez">
                  {SOPORTE_EMAIL}
                </a>
              </li>
              <li className="flex items-center gap-2" data-id="element-45" data-mp="3q7u1bojhypzf">
                <InstagramIcon className="h-4 w-4 shrink-0 text-oro" aria-hidden="true" data-id="element-46" data-mp="830iphfda2zy" />
                <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className={linkClass} data-id="element-47" data-mp="80nvaoqub0fi">
                  {INSTAGRAM_USER}
                </a>
              </li>
              <li className="flex items-center gap-2" data-id="element-48" data-mp="cu8swfoitse6">
                <GlobeIcon className="h-4 w-4 shrink-0 text-oro" aria-hidden="true" data-id="element-49" data-mp="qt03hs46cvxk" />
                <a href={WEB_URL} target="_blank" rel="noopener noreferrer" className={linkClass} data-id="element-50" data-mp="ms6gr22gxn69">
                  {WEB_LABEL}
                </a>
              </li>
            </ul>
          </div>

          <nav aria-label="Enlaces legales" className="sm:text-right" data-id="element-51" data-mp="yty0xuoj2v56">
            <ul className="flex flex-wrap gap-x-4 gap-y-1.5 text-[13px] sm:flex-col sm:gap-y-2 sm:text-sm" data-id="element-52" data-mp="ys3eud1iswzi">
              <li data-id="element-53" data-mp="13rg0iugnny0i">
                <a href="#" className={linkClass} data-id="element-54" data-mp="18jr17zj7znu4">
                  Términos y condiciones
                </a>
              </li>
              <li data-id="element-55" data-mp="1ckkpiu0kr4nj">
                <a href="#" className={linkClass} data-id="element-56" data-mp="1cl2qg3y6m71s">
                  Política de privacidad
                </a>
              </li>
              <li data-id="element-57" data-mp="1hmifs87e6zpz">
                <a href="#faq" className={linkClass} data-id="element-58" data-mp="1mk1utabwzgiz">
                  Preguntas frecuentes
                </a>
              </li>
            </ul>
          </nav>
        </div>

        <div className="mt-5 border-t border-white/10 pt-4" data-id="element-59" data-mp="1rgiqcplg0x63">
          <p className="text-[12px] text-white/50 sm:text-[13px]" data-id="element-60" data-mp="3ocgg8jdo3345">
            © Creativo Digital™ 2026 — Todos los derechos reservados.
          </p>
          <p className="mt-2 max-w-4xl text-[11px] leading-[1.6] text-white/40 sm:text-xs" data-id="element-61" data-mp="2aevdxsrcbo5s">
            SOS Veraz es un material educativo e informativo sobre datos crediticios y derechos del
            titular. No constituye asesoramiento legal ni garantiza resultados. Los procedimientos
            explicados se refieren al ejercicio de los derechos de acceso, rectificación,
            actualización y supresión de datos personales cuando correspondan. Creativo Digital y SOS
            Veraz no tienen relación, afiliación ni representación oficial con Veraz, Equifax ni el
            BCRA.
          </p>
        </div>
      </div>
    </footer>;
}